const topics = [
  { name: '顶流恋情', heat: '128万', tag: '爆', color: 'primary' },
  { name: '综艺争议', heat: '96万', tag: '热', color: 'accent' },
  { name: '网红翻车', heat: '83万', tag: '热', color: 'accent' },
  { name: '选秀黑幕', heat: '71万', tag: '新', color: 'secondary' },
  { name: '直播互撕', heat: '65万', tag: '热', color: 'accent' },
  { name: '影视爆料', heat: '58万', tag: '新', color: 'secondary' },
  { name: '品牌纠纷', heat: '47万', tag: '', color: 'secondary' },
  { name: '经纪内幕', heat: '39万', tag: '', color: 'secondary' },
  { name: '明星塌房', heat: '32万', tag: '', color: 'secondary' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          话题广场
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          当前最火爆的黑料话题标签，点击直达相关爆料内容
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => {
            const colorClasses = topic.color === 'primary'
              ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100 hover:border-primary-300'
              : topic.color === 'accent'
              ? 'bg-accent-50 border-accent-200 text-accent-700 hover:bg-accent-100 hover:border-accent-300'
              : 'bg-secondary-50 border-secondary-200 text-secondary-700 hover:bg-secondary-100 hover:border-secondary-300';

            return (
              <a
                key={topic.name}
                href="#cards"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-colors cursor-pointer no-underline ${colorClasses}`}
              >
                <span className="whitespace-nowrap">{topic.name}</span>
                {topic.tag && (
                  <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded-full whitespace-nowrap ${
                    topic.tag === '爆' ? 'bg-primary-500 text-background-50' :
                    topic.tag === '热' ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {topic.tag}
                  </span>
                )}
                <span className="text-xs opacity-60 whitespace-nowrap">{topic.heat}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}